import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import 'dayjs/locale/zh-cn';

import utc from 'dayjs/plugin/utc';

dayjs.locale('zh-cn');
dayjs.extend(relativeTime);
dayjs.extend(utc);

export default dayjs;
